<template>
    <div class="animated fadeIn">
        <b-row class="mb-4">
            <b-col sm="12" lg="12" >
                <h3 class="pull-left mb-0">Products</h3>
                <b-button v-if="selections.length" class="pull-right" variant="primary" @click.stop="updateOrder()" :disabled="busy"><span v-if="busy && selections.length">Saving...</span><span v-else>Save</span></b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="8">
                <b-card no-body v-if="selections.length">
                    <b-card-body>
                        <b-list-group>  
                            <draggable v-model="selections" :options="{ draggable: '.item' }">             
                                <b-list-group-item  v-if="selections" v-for="(selection,index) in selections" :key="index" class="flex-column align-items-start item">
                                    <div class="d-flex w-100">
                                        <div class="product-image">
                                            <img v-if="selection.product.image_path !== '/'" :src="gdp_root + selection.product.image_path" />
                                            <img v-else :src="gdp_root + 'images/products/default.jpg'" />
                                        </div>
                                        <div>
                                            <h5 class="mb-1">{{ selection.product.title }}</h5>
                                            <small class="text-danger">₱ {{ selection.product.price }}</small>  <small v-if="selection.product.description" class="text-muted"> - {{ selection.product.description }}</small>  
                                            <div class="mt-1">
                                                <b-form-checkbox value='1' unchecked-value='0' v-model="selection.show_in_app" @change.native.stop.prevent="updateSelection(selection.id,'show_in_app',selection.show_in_app)">Show in App</b-form-checkbox>
                                                <b-form-checkbox value='1' unchecked-value='0' v-model="selection.show_in_messenger" @change.native.stop.prevent="updateSelection(selection.id,'show_in_messenger',selection.show_in_messenger)">Show in Bot</b-form-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </b-list-group-item>  
                            </draggable>  
                        </b-list-group>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col sm="12" md="4" v-if="selections.length">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="mb-3">Settings</h4>
                        <b-list-group>                    
                            <b-list-group-item class="flex-column align-items-start">
                                <div >
                                    <b-form>
                                        <b-form-group validated 
                                            label="Minimum Order Amount"
                                            label-for="minOrder"
                                            description="">
                                            <b-input-group prepend="₱">
                                                <b-form-input id="minOrder" type="number" v-model="settings.min_amount" required autocomplete="off"></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group validated
                                            label="Charge"
                                            label-for="charge"
                                            description="">
                                            <b-input-group prepend="₱">
                                                <b-form-input id="charge" type="number" v-model="settings.min_charge" required autocomplete="off"></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group
                                            label="Contact Number"
                                            label-for="contact"
                                            description="">
                                            <b-form-input id="contact" type="number" v-model="settings.contact" required autocomplete="off"></b-form-input>
                                        </b-form-group>
                                    </b-form>
                                </div>
                            </b-list-group-item>  
                        </b-list-group>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'products',
  components: {
      draggable,
  },
  data: function () {
    return {
        gdp_root: GDP_ROOT,
        selections: [],
        products: [],
        order: [],
        list: [],
        busy: false,
        settings: {
            min_amount: 0,
            min_charge: 0,
            contact: ''
        }
    }
  },
  methods: {
    loadProducts(table = 'selections') {
      this.busy = true
      axios.get(API_URL + table)
        .then(response => {
          if (table === 'selections') {
            this.selections = response.data.data
            if (response.data.settings) this.settings = response.data.settings
          } else {
            this.products = response.data.data;
          }
          //console.log(this.selections)
          this.busy = false
        })
        .catch(error => {
          this.busy = false
          //clc.errorHandler(error)
        })
    },
    updateOrder () {
        this.$nextTick(function () {
            this.busy = true
            axios.post(API_URL + 'selections/sort', { selections: this.selections, settings: this.settings  })
                .then(response => {
                    alert('Saved! Product lists in app and bot may take 5 mins or more to reflect the update.')
                    this.busy = false
                })
                .catch(error => {
                    this.busy = false
                    alert('Something went wrong. Please try again')
                })
        })
    },
    updateSelection (id,select,val) {
        this.$nextTick(function () {
            this.busy = true
            if (val > 0) {
                val = '0'
            } else {
                val = 1
            }
            axios.post(API_URL + 'selections/update', { id: id, show: select, value: val  })
                .then(response => {
                    //alert('Product selection saved')
                    this.busy = false
                })
                .catch(error => {

                    this.busy = false
                    alert('Something went wrong. Please try again')
                })
        })
    }
  },
  mounted() {
      this.loadProducts() 
  }
}
</script>

<style>
    .opacity-50 {
        opacity: 0.5;
    }
    .product-image {
        width: 72px;
        height: 72px;
        overflow: hidden;
        margin-right: 15px;
        border-radius: 3px
    }
    .product-image img {
        width: 100%;
    }
</style>
